import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const truncateText = (text: string, length: number) => {
  const summary = text.trim().slice(0, length);
  return summary.length === length ? `${summary} ...` : summary;

}